import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { useTranslation } from 'core/i18n';

export interface CustomAlarmDeactivateCommandComponentProps {
    onClick: VoidFunction;
}

export const CustomAlarmDeactivateCommandComponent: React.FC<CustomAlarmDeactivateCommandComponentProps> = (props) => {
    const { t } = useTranslation();
    const { onClick } = props;

    return (
        <PocListItem data-testid="custom-alarm-deactivate-command" onClick={onClick}>
            <PocIcon slot="prefix" name="circle_remove" family="outlined" />
            {t('settings.devices.custom-alarms.actions.deactivate')}
        </PocListItem>
    );
};
